import { useQuery } from 'react-query';
import { queryGet } from './fetch';

export type GroupedCountResult = Record<
  string,
  Record<string, Record<string, number>>
>;

export const useGroupedParticipationFieldAnswersCount = (
  sessionId?: string,
) => {
  return useQuery<GroupedCountResult>(
    ['sessions', sessionId, 'participation-field-answers', 'grouped-count'],
    queryGet(
      `/sessions/${sessionId}/participation-field-answers/grouped-count`,
    ),
    {
      enabled: !!sessionId,
    },
  );
};
